// Converts snake_case strings to Title Case
// Ex. "in_progress" => "In Progress"
const snakeCaseToTitleCase = (input: string): string => {
  // Split the input string by underscores to get individual words
  const words = input.split('_');

  // Capitalize the first letter of each word and join them with spaces
  const titleCaseString = words
    .map((word) => {
      // Capitalize the first letter of the word and make the rest lowercase
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');

  return titleCaseString;
};

export default snakeCaseToTitleCase;
